<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right"
                   style="font-size: 20px; padding: 20px 10px 20px; background-color: #e6e5e5;">
      <el-breadcrumb-item>Generation</el-breadcrumb-item>
      <el-breadcrumb-item>Structure-based</el-breadcrumb-item>
    </el-breadcrumb>
    <p class="content">The Structure-based module implements an automated structure-based molecular
        generation pipeline within AIDrugDesigner. The workflow integrates pocket detection
        using fpocket, enabling end-to-end target-guided design in a unified environment.
        Users can upload a PDB structure or provide a PDB ID, upon which the server
        automatically identifies binding pockets and performs structure-guided molecular
        generation based on the detected pocket region. The output includes generated
        candidate molecules in SMILES format, together with predicted physicochemical
        properties and interactive visualization results.</p>
    <structure-based-form></structure-based-form>

  </div>
</template>

<script>
import StructureBasedForm from "@/components/StructureBasedForm";

export default {
  name: "Structure-based",
  components: {StructureBasedForm}
}
</script>

<style scoped>
div {
  max-width: 1160px;
  margin: 0 auto;
}

p {
  /*padding: 20px 0 20px;*/
  text-align: left!important;
  line-height: 1.5em;
}
.content{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
}
</style>
